export enum EventTypeEnumerate {
  APP_MENU_CLICK = 'app.menu_click',
  APP_MINICART_ITEM_CLICK = 'app.minicart_item_click',
  APP_SEARCH_ITEM_CLICK = 'app.search_item_click',
}
